import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ReclamationHandlingMethodsDataGrid } from "src/components/views/erp/reclamation/masterData/ReclamationHandlingMethodsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/reclamations/reclamationHandlingMethod")({
	staticData: { title: i18n.t("reclamation_handling_methods"), legacyViewKey: "reclamationHandlingMethodsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ReclamationHandlingMethodsDataGrid />;
}
